<template>
  <FAQSectionLayout>
    <div class="faq-list">
      <div class="faq-half-list">
        <FAQUnit
          type="billing"
          title="How is Shortform better than other sites?"
        >
          We know there are a few summary providers out there. What we're famous
          for are our comprehensive, detailed book summaries. We cover far more
          ideas than our competitors, while still being concise. Compare one of
          our books to one of theirs, and you'll see how much useful information
          they leave out. Our summaries also feature interactive exercises and
          emphasize actionables, so you put the information you learn into
          practical use. Finally, we cover articles from leading publications
          like
          <em>The New York Times</em> and <em>The Economist</em>, so you get
          access to more great ideas.
        </FAQUnit>
        <FAQUnit
          type="billing"
          title="How much new content do you publish each month?"
        >
          We currently publish 20+ new book summaries a month, as well as 40+
          new article summaries. We're continuing to grow our writing team to
          cover more great ideas every day.
        </FAQUnit>
        <FAQUnit type="billing" title="What genres do you cover?">
          Our summaries cover 30+ genres, including self-improvement, business,
          technology, spirituality, history, and politics. Our mission is to
          spread the world's best ideas, and that means writing broadly to cover
          all our subscribers' interests.
        </FAQUnit>
      </div>
      <div class="faq-half-list">
        <FAQUnit type="billing" title="Can I suggest materials to summarize?">
          Yes! We take book suggestions from our subscribers all the time. Once
          you request a book, it'll be added to our shortlist of books to cover.
          The more often the book is requested, the sooner we'll publish our
          summary.
        </FAQUnit>
      </div>
    </div>
  </FAQSectionLayout>
</template>

<script setup lang="ts">
import FAQSectionLayout from './FAQSectionLayout.vue'
import FAQUnit from './FAQUnit.vue'
</script>
